var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":""}},[(_vm.isActive)?_c('div',{staticClass:"pageLoaderWrap",style:({backgroundColor:_vm.bgColor})},[_c('div',{staticClass:"pageLoader"},[_c('img',{attrs:{"src":_vm.imagePath}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }